import o from"react";import{MdIcon as t}from"./MdIcon.js";import{mdiFacebook as e}from"@mdi/js";const r=({id:r="facebook",title:i="Facebook",...m})=>o.createElement(t,{id:r,title:i,path:e,...m});export{r as FacebookIcon};
